﻿/*****
    Author:	    CT Software Systems, LLC
    Last Modified: 260112
*/
'use strict';
import { getPromise, savePromise } from './ctssJQuery.js';
import { getAppToken } from './snSite.js';

const token = getAppToken();

const getGroupLeadersAsync = async (params) =>
    await getPromise({ url: `GroupLeaders/${token.CG}` });

const getGroupLeaderGroupIDsAsync = async (params) =>
    await getPromise({ url: `GroupLeaders/GroupIDs/${token.MG}` });

const saveGroupLeaderAsync = async (params = {}) => {

    const { groupID, memberID, isLeader, divErrMsg, btnId } = params;

    if (!groupID || !memberID || isLeader === undefined || isLeader === null) {
        alert('groupID, memberID, and isLeader are required params for snGroupLeaders.saveAsync!');
        return;
    }

    return await savePromise({
        url: 'GroupLeaders',
        data: {
            cg: token.CG,
            groupID,
            memberID,
            isLeader
        },
        divErrMsg,
        btnId
    });
}

export {
    getGroupLeadersAsync,
    getGroupLeaderGroupIDsAsync,
    saveGroupLeaderAsync
}